import * as angular from "angular";
import * as _ from "lodash";
import {SplitService} from "../services/split-service.service";

angular
  .module('bringoz.admin.commons')
  .filter('omsPackagesWeight', packageWeight);

function packageWeight($filter, splitService: SplitService) {
  return function packageWeightFilter(itemLines, enableUnitDisplay) {
    const countAsTotal = splitService.getPackageWeightIsTotal();

    const itemsWeightSum = itemLines.reduce((sum, packageRef) => {
      const weight = packageRef.weight;
      return weight ? (countAsTotal ? (weight + sum) : (weight * (packageRef.count || 1) + sum)) : sum;
    }, 0);

    return itemsWeightSum ? $filter('bringozWeight')(itemsWeightSum, enableUnitDisplay) : '--';
  }
}
